/* unplugin-vue-components disabled */import { render } from "./success.vue?vue&type=template&id=4026819e&scoped=true&ts=true"
import script from "./success.vue?vue&type=script&lang=ts"
export * from "./success.vue?vue&type=script&lang=ts"

import "./success.vue?vue&type=style&index=0&id=4026819e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\17532\\Desktop\\智慧校园\\school-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4026819e"]])

export default __exports__